import React, { useState } from "react";

import { useUser } from "store/providers/app";

import { getIndicatorsDashboard, getIndicatorsListByUser } from "services/Indicators.service";
import Loading from "../Loading";
import PaginationTable from "../Pagination";

import {useQuery} from 'react-query';
import {ButtonsTable} from "components/Buttons";
import {useIndicator} from "contexts/IndicatorsContext";
import {toast} from "react-toastify";

export default function TableIndicator({
        selected,
        status = '',
        trashed = false,
        language = 'pt-BR',
        title,
        year_reference
    }) {

    const [data, setData] = useState([]);
    const [paginate, setPaginate] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);

    const [authStatus, setAuthStatus] = useState(false)

    const {user} = useUser();

    const {changeTotalIndicators} = useIndicator();

    const key = status ? status : trashed && "trashed"

    const filter = selected ? selected?.replace('+', '%2B') : '';

    const {isLoading, isFetching} = useQuery(['indicators', key, currentPage, filter, year_reference],
        () => {
            if(user.profile === 2 || user.profile === 3) {
               // const type = user.profile === 2 ? 1 : 2
                return getIndicatorsListByUser({
                    user_id: user.id,
                    paginate: true,
                    currentPage,
                    status: key,
                    q: filter,
                    language,
                    year_reference
                })
            } else {
                return getIndicatorsDashboard(filter, status, currentPage, language, year_reference)
            }

        }, {
            onSuccess: (res) => {
                if (!trashed) {
                    changeTotalIndicators(status, res.meta.total, language)
                }

                setData(res.data)
                setPaginate(res.meta)
            },
            onError: (err) => {
                console.log('erro lista de indicadores ->', err)
                toast.error('Falha na requisição');
            },
            retry: 1,
            refetchOnWindowFocus: false,
            keepPreviousData: true,
        }
    )

    const handlePageClick = (event) => {
        setCurrentPage(event.selected + 1)
    };

    const updateAuthStatus = (status) => {
        setAuthStatus(status)
    }

    if (isLoading) return <Loading/>

    return (
        <div className="accordion accordion-flush shadow-sm rounded mt-3" id={`accordion-${status}-indicator-${language}`}>
            <div className="accordion-item rounded">
                <h2 className="accordion-header" id={`heading-${status}-indicator-${language}`}>
                    <button className={`accordion-button rounded-top ${!selected && "collapsed"} `}
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target={`#panel-${status}-indicator-${language}`} aria-expanded={!!selected}
                            aria-controls="flush-collapseOne">
                        <span className="fs-6 fw-medium">
                            {title ?? 'Ocultados'}
                        </span>
                    </button>
                </h2>
                <div id={`panel-${status}-indicator-${language}`} className={`accordion-collapse collapse ${selected && "show"}`}
                     aria-labelledby={`heading-${status}-indicator-${language}`} data-bs-parent={`#accordion-${status}-indicator`}>
                    <div className="accordion-body p-0">
                        <div className="table-responsive">
                            <table
                                className={`table table-hover align-middle mb-0 ${isFetching && "text-muted"}`}>
                                <tbody>

                                {!data?.length &&
                                    <tr>
                                        <td className="text-sm">Nenhum registro encontrado</td>
                                    </tr>
                                }

                                { data?.map((item) => {
                                   return (
                                       <tr key={item.id}>
                                            <td className="text-wrap text-sm">
                                                <span className="text-muted fw-bolder text-">{item.codigo} </span> - { item.titulo } - { item.year_reference }
                                            </td>
                                            <td>
                                                <ButtonsTable
                                                    trashed={trashed}
                                                    id={item.id}
                                                    code={item.codigo}
                                                    title={item.titulo}
                                                    isFetching={isFetching}
                                                    status={item.status}
                                                    authStatus={authStatus}
                                                />
                                            </td>
                                        </tr>
                                   )}
                                )}
                                </tbody>
                            </table>
                        </div>

                        {data?.length > 0 &&
                            <div className="py-3">
                                <PaginationTable
                                    isFetching={isFetching}
                                    paginate={paginate}
                                    handlePageClick={handlePageClick}
                                />
                            </div>
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}
